import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import swal, { SweetAlertResult } from 'sweetalert2';

export enum S1PopUpType {
  Success = "success",
  Warning = "warning",
  Error = "error",
  Info = "info",
  Question = "question"
}

@Injectable({
  providedIn: 'root'
})
export class S1UIService {

  constructor(private translate: TranslateService, private toasterService: ToastrService) { 
    
  }

  // Spinner
  showSpinner() {

    swal.fire({
      title: this.translate.instant('s1.swal.loading'),
      onOpen: function () {
          swal.showLoading();
      }
    });

  }

  closeSpinner() {
    swal.close();
  }

  // Popup
  showPopup(type: S1PopUpType, title?: string, text?: string) {

    swal.fire(this.translate.instant(title),this.translate.instant(text)  , type);

  }

  showPopupNoPermission() {
    this.showPopup(S1PopUpType.Warning, 's1.swal.attention',  's1.swal.noPermission')
  }

  async showHTTPErrorPopup(error: any) {

    let errorTitle = 's1.error'
    let errorMessage = 'genericError'

    //console.log("Error: ", error);

    const text = error.error?.text;

    if (error?.error instanceof Blob) { // Caso particolare, con errore 400 viene tornato un Blob
      const errorJson = await JSON.parse(await error?.error.text());
      errorMessage = this.translate.instant(errorJson?.outcome?.errorMessage);
    } else if (text && typeof(text) === 'function') { // Caso particolare viene tornata una stringa
      const errorLbl = await error.error?.text();
      errorMessage = this.translate.instant(errorLbl);
    } else if (error.error?.outcome?.errorDescription) {
      errorMessage = this.translate.instant(error.error?.outcome?.errorDescription);
    } else if (error.error?.outcome?.errorMessage) {
      errorMessage = this.translate.instant(error.error?.outcome?.errorMessage);
    } else if (error.statusText) {
      errorMessage = this.translate.instant(error.statusText);
    }

    if (error.status) {

      errorTitle = "" + error.status

      switch(error.status) {
        //case 401: // Unauthorized
        case 403: // Forbidden
          errorMessage = this.translate.instant('APIErrors.' + error.status)
          break;
      }

    }

    this.showPopup(S1PopUpType.Error, errorTitle, errorMessage)

  }

  showDialogPopup(title: string): Promise<SweetAlertResult> {

    return swal.fire({
      title: this.translate.instant('s1.swal.attention'),
      text: this.translate.instant(title),
      icon: S1PopUpType.Question,
      showCloseButton: true,
      showCancelButton: true,
      customClass: {
        cancelButton: 'btn btn-xs btn-danger'
      }
    })

  }

  /*showSelectionPopup(title: string, elementList: any): Promise<any> {

    return swal({
      title: this.translate.instant(title),
      type: "question",
      input: 'radio',
      inputOptions: elementList
    });

  }
*/
  showInputPopup(title: string, text: string, fieldText: string, initialValue: string = null): Promise<any> {

    return swal.fire({
      title: this.translate.instant(title),
      text: this.translate.instant(text),
      input: 'text',
      inputValue: initialValue,
      inputPlaceholder: this.translate.instant(fieldText),
    });

  }

  // TOAST
  showSuccessToast(text: string) {
    this.toasterService.success(this.translate.instant(text), this.translate.instant("s1.toast.success"), { timeOut: 1000 });
  }

}
